import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, FormControl, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';

export class DayTypeForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data,
            nameInputError: null
        }
    }

    // -----------------

    onChangeValue(e, property) {
        const { data } = this.state;

        data[property] = e.target.value;

        this.setState({
            data: data
        });
    }

    onSave() {
        if (this.validInput()) {
            const { data } = this.state;
            this.props.onSave(data);
        }
    }

    validInput() {
        let errors = 0;
        let nameInputError = null;

        const { data } = this.state;

        if ("" === data.name || null === data.name || undefined === data.name) {
            nameInputError = 'error';
            errors++;
        }

        this.setState({
            nameInputError: nameInputError
        });

        return errors > 0 ? false : true;
    }

    // -------------------

    render() {
        const { data, nameInputError } = this.state;

        if (undefined === data || null === data) {
            return null;
        }

        const { title } = this.props;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formNamePt" validationState={nameInputError}>
                            <ControlLabel>Nome</ControlLabel>
                            <FormControl
                                type="text"
                                value={data.name}
                                onChange={(e) => this.onChangeValue(e, "name")} />

                            {
                                nameInputError !== null ?
                                    <HelpBlock> Este campo não pode estar vazio. </HelpBlock> :
                                    null
                            }
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/dayTypes/DayTypeForm.js